import { Col, message, Row, Form as FormInitial, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    InputItem,
    ButtonItem,
    SwitchItem,
    ErrorItem,
    TextAreaItem,
    SelectItem,
    TransferItem,
} from "../../../../Components/Items";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

const { Option } = Select;

// Mismas opciones que la card de insumos de la familia.
const IMPUESTOS = [
    "ISH 15%", "ISH 10%", "ISH 6%", "ISH 5%", "ISH 4%", "ISH 3.75%",
    "ISH 3.5%", "ISH 3%", "ISH 2.5%", "ISH 2%",
    "IEPS 160%", "IEPS 53%", "IEPS 50%", "IEPS 30.40%", "IEPS 30%",
    "IEPS 26.5%", "IEPS 25%", "IEPS 9%", "IEPS 8%", "IEPS 7%",
    "IEPS 6%", "IEPS 3%",
    "IVA 16% (Especial)", "IVA Exento", "IVA 0%", "IVA 8%", "IVA 16%",
];

const RETENCIONES = [
    "Ret. 4% Fletes",
    "Ret. ISR 1.25% RESICO Servicios Profesionales",
    "Ret. 1.25% ISR RESICO Arrendamiento",
    "Retención ISR 10% Servicios Profesionales",
    "Retención ISR 10% Arrendamiento",
    "Retención IVA 10.6667%",
];

const SeccionTitulo = ({ numero, titulo, color, nota }) => (
    <div
        style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            flexWrap: "wrap",
            marginBottom: 10,
            paddingBottom: 6,
            borderBottom: "2px solid " + color + "40",
        }}
    >
        <span
            style={{
                width: 20,
                height: 20,
                borderRadius: "50%",
                background: color,
                color: "#fff",
                fontSize: 11,
                fontWeight: 700,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                flex: "none",
            }}
        >
            {numero}
        </span>
        <span
            style={{
                fontSize: 13,
                fontWeight: 700,
                letterSpacing: 0.5,
                textTransform: "uppercase",
                color: "#3c4b53",
            }}
        >
            {titulo}
        </span>
        {nota ? <span style={{ fontSize: 11.5, color: "#7b8a92" }}>{nota}</span> : null}
    </div>
);

const SubTitulo = ({ children }) => (
    <div
        style={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: 0.5,
            textTransform: "uppercase",
            color: "#262626",
            borderBottom: "1px solid #f0f0f0",
            paddingBottom: 4,
            marginBottom: 6,
        }}
    >
        {children}
    </div>
);

// Un solo componente para agregar y editar: si viene insumoId, se piden sus
// datos y se manda a editarInsumoImplementacion.
class AgregarInsumoImplementacion extends Component {
    formRef = React.createRef();
    contenidoRef = React.createRef();
    state = {
        loading: false,
        todasFamilias: [],
    };
    // La pantalla le pone un key con el id, asi que al picarle Editar este
    // componente se monta de nuevo ya con visible=true: sin esto no hay
    // transicion que detectar en componentDidUpdate y el modal sale vacio.
    componentDidMount() {
        if (this.props.visible) this.abrir();
    }
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.abrir();
        }
    }
    abrir() {
        this.formRef.current?.resetFields();
        this.consultarTodo();
        if (this.contenidoRef.current) this.contenidoRef.current.scrollTop = 0;
    }
    cerrarAgregarInsumoImplementacion(guardado) {
        this.props.cerrarAgregarInsumoImplementacion(guardado);
    }
    // Las familias se piden con el mismo endpoint que llena la tabla de la
    // pantalla, igual que en Agregar Industria.
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "familiasImplementacion/selectTodasFamiliasImplementacion",
                { page: 1, pageSize: 1000, valor: 3, filters: {} },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({
                    todasFamilias: res.data.success === 2 ? res.data.data : [],
                });
            })
            .catch(() => this.setState({ todasFamilias: [] }));

        if (this.props.insumoId) await this.consultarInsumo();
        this.setState({ loading: false });
    }
    async consultarInsumo() {
        await axios
            .post(
                "insumosImplementacion/datosInsumoImplementacion",
                { insumoImplementacionId: this.props.insumoId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                const datos =
                    res.data?.data || res.data?.insumoImplementacion || res.data?.insumo;
                if (res.data.success === 2 && datos) {
                    this.formRef.current?.setFieldsValue({
                        ...datos,
                        // Pueden venir pobladas; el dual list trabaja con ids.
                        familiaImplementacionIds: (datos.familiaImplementacionIds || []).map(
                            (familia) =>
                                familia && typeof familia === "object" ? familia._id : familia
                        ),
                    });
                } else {
                    message.error("Error no se encontro informacion del insumo");
                }
            })
            .catch(() => message.error("Error no se encontro informacion del insumo"));
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        const editando = !!this.props.insumoId;
        const cuerpo = { ...values };
        if (editando) cuerpo.insumoImplementacionId = this.props.insumoId;

        this.setState({ loading: true });
        axios
            .post(
                editando
                    ? "insumosImplementacion/editarInsumoImplementacion"
                    : "insumosImplementacion/agregarInsumoImplementacion",
                cuerpo,
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success(editando ? "Insumo editado" : "Se ha registrado un insumo");
                    this.formRef.current.resetFields();
                    this.cerrarAgregarInsumoImplementacion(true);
                } else if (res.data.success === 1) {
                    message.error(
                        editando ? "No se puede editar el insumo" : "No se puede registrar el insumo"
                    );
                } else {
                    message.error("Hubo un error y el insumo no se guardo");
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Hubo un error y el insumo no se guardo");
            });
    }

    renderSwitch = (campo, etiqueta) => (
        <span
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 5,
                fontSize: 11.5,
                fontWeight: 600,
                color: "#5a6a72",
            }}
        >
            {etiqueta}
            <FormItem name={campo} initialValue={false} valuePropName="checked" noStyle>
                <SwitchItem size="small" />
            </FormItem>
        </span>
    );

    // Impuestos y retenciones comparten forma: lista dinamica de { nombre }.
    renderListaNombres = (campo, titulo, opciones, textoBoton, placeholder) => (
        <FormInitial.List name={campo}>
            {(fields, { add, remove }) => (
                <>
                    <SubTitulo>{titulo}</SubTitulo>
                    <div style={{ marginBottom: fields.length > 0 ? 6 : 0 }}>
                        <ButtonItem cyan lessTime onClick={() => add()} icon={<PlusOutlined />}>
                            {textoBoton}
                        </ButtonItem>
                    </div>
                    {fields.map(({ name }, idx) => (
                        <Row gutter={6} align="middle" key={idx} style={{ marginBottom: 3 }}>
                            <Col flex="auto">
                                <FormItem name={[name, "nombre"]} margin pattern>
                                    <SelectItem placeholder={placeholder}>
                                        {opciones.map((opcion) => (
                                            <Option key={opcion} value={opcion}>
                                                {opcion}
                                            </Option>
                                        ))}
                                    </SelectItem>
                                </FormItem>
                            </Col>
                            <Col flex="22px" style={{ textAlign: "center" }}>
                                <MinusCircleOutlined
                                    onClick={() => remove(name)}
                                    style={{ color: "#ff4d4f", cursor: "pointer" }}
                                />
                            </Col>
                        </Row>
                    ))}
                </>
            )}
        </FormInitial.List>
    );

    render() {
        const editando = !!this.props.insumoId;
        const familiasTransfer = this.state.todasFamilias
            .filter((familia) => familia.estado === 1)
            .map((familia) => ({
                key: familia._id,
                title: familia.nombre,
                description: familia.tipoDeFamilia || "",
            }));

        return (
            <ModalItem
                title={editando ? "Editar Insumo Implementacion" : "Agregar Insumo Implementacion"}
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={() => this.cerrarAgregarInsumoImplementacion()}
                width={window.innerWidth > 1200 ? "70%" : "95%"}
                paddingTop
            >
                <Form
                    ref={this.formRef}
                    name="agregarInsumoImplementacion"
                    layoutForm="vertical"
                    bottom={
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <ButtonItem type="primary" cyan htmlType="submit">
                                {editando ? "Guardar" : "Agregar"}
                            </ButtonItem>
                        </div>
                    }
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <div
                        ref={this.contenidoRef}
                        className="scrollbar-pequeña"
                        style={{
                            maxHeight: "calc(100vh - 310px)",
                            minHeight: 240,
                            overflowY: "auto",
                            overflowX: "hidden",
                            paddingRight: 6,
                        }}
                    >
                        {/* ========== 1 · INSUMO ========== */}
                        <div
                            style={{
                                background: "#fff",
                                border: "1px solid #eef1f2",
                                borderRadius: 12,
                                padding: "10px 14px 6px 14px",
                                marginBottom: 14,
                            }}
                        >
                            <SeccionTitulo
                                numero={1}
                                titulo="Insumo"
                                color="#FF6A0D"
                                nota="El número y la serie los asigna el sistema."
                            />
                            <Row gutter={[12, 0]}>
                                <Col xs={24} sm={12} md={5}>
                                    <FormItem name="clave" label="Clave" required margin pattern>
                                        <InputItem placeholder="Clave" />
                                    </FormItem>
                                </Col>
                                <Col xs={24} sm={12} md={7}>
                                    <FormItem name="unidad" label="Unidad" margin pattern>
                                        <InputItem placeholder="Ej. PZA, KG (preferible SAT)" />
                                    </FormItem>
                                </Col>
                                <Col xs={24} sm={12} md={8}>
                                    <FormItem
                                        name="descripcion"
                                        label="Descripción"
                                        required
                                        margin
                                        pattern
                                    >
                                        <InputItem placeholder="Descripción" />
                                    </FormItem>
                                </Col>
                                <Col xs={24} sm={12} md={4}>
                                    <FormItem name="costo" label="Costo" margin pattern>
                                        <InputItem placeholder="0" />
                                    </FormItem>
                                </Col>
                                <Col xs={24} md={14}>
                                    <FormItem
                                        name="descripcionLarga"
                                        label="Descripción larga"
                                        margin
                                        pattern
                                    >
                                        <TextAreaItem
                                            placeholder="Descripción larga"
                                            autoSize={{ minRows: 2, maxRows: 4 }}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={24} md={10}>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 14,
                                            flexWrap: "wrap",
                                            marginTop: 26,
                                        }}
                                    >
                                        {this.renderSwitch("venta", "Venta")}
                                        {this.renderSwitch("compra", "Compra")}
                                        {this.renderSwitch("inventariable", "Inventariable")}
                                    </div>
                                </Col>
                            </Row>
                        </div>

                        {/* ========== 2 · IMPUESTOS Y RETENCIONES ========== */}
                        <div
                            style={{
                                background: "#fff",
                                border: "1px solid #eef1f2",
                                borderRadius: 12,
                                padding: "10px 14px 6px 14px",
                                marginBottom: 14,
                            }}
                        >
                            <SeccionTitulo
                                numero={2}
                                titulo="Impuestos y retenciones"
                                color="#00BFD6"
                                nota="Se buscan por nombre al implementar, deben existir igual."
                            />
                            <Row gutter={[18, 0]}>
                                <Col xs={24} md={12}>
                                    {this.renderListaNombres(
                                        "impuestos",
                                        "Impuestos",
                                        IMPUESTOS,
                                        "Agregar impuesto",
                                        "Ej. IVA"
                                    )}
                                </Col>
                                <Col xs={24} md={12}>
                                    {this.renderListaNombres(
                                        "retenciones",
                                        "Retenciones",
                                        RETENCIONES,
                                        "Agregar retención",
                                        "Ej. ISR"
                                    )}
                                </Col>
                            </Row>
                        </div>

                        {/* ========== 3 · FAMILIAS ========== */}
                        <div
                            style={{
                                background: "#fff",
                                border: "1px solid #eef1f2",
                                borderRadius: 12,
                                padding: "10px 14px 6px 14px",
                                marginBottom: 14,
                            }}
                        >
                            <SeccionTitulo
                                numero={3}
                                titulo="Familias"
                                color="#00BFD6"
                                nota="Pasa a la derecha las familias donde se usa este insumo."
                            />
                            <FormItem
                                name="familiaImplementacionIds"
                                valuePropName="targetKeys"
                                initialValue={[]}
                                margin
                            >
                                <TransferItem
                                    dataSource={familiasTransfer}
                                    titles={["Familias disponibles", "Familias del insumo"]}
                                    listStyle={{ flex: 1, height: 300 }}
                                    render={(item) =>
                                        item.description
                                            ? item.title + " · " + item.description
                                            : item.title
                                    }
                                    filterOption={(texto, item) =>
                                        (item.title + " " + item.description)
                                            .toLowerCase()
                                            .indexOf(texto.toLowerCase()) >= 0
                                    }
                                    locale={{
                                        itemUnit: "familia",
                                        itemsUnit: "familias",
                                        searchPlaceholder: "Buscar familia",
                                        notFoundContent: "Sin familias",
                                    }}
                                />
                            </FormItem>
                        </div>
                    </div>
                </Form>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
    };
};

export default connect(mapStateToProps)(AgregarInsumoImplementacion);
